import { Routes } from '@angular/router';
import { SubscriptionPlanGuard } from '@app/shared/subscription-plan/subscription-plan.guard';

import { PermissionGuard } from '../permission-guard.service';
import { defaultInsightView } from './helpers/view.helper';
import { insightsRoutesGuard } from './insights-routes.guard';
import { insightsAccess } from './insights.access';

export const insightsRoutes: Routes = [
  {
    path: 'insights',
    data: {
      ...insightsAccess.insights,
    },
    canActivate: [SubscriptionPlanGuard, PermissionGuard],
    children: [
      {
        path: ':view',
        loadComponent: () => import('./insights-page.component').then((m) => m.InsightsPageComponent),
        canActivate: [insightsRoutesGuard],
      },
      {
        path: '',
        redirectTo: defaultInsightView,
        pathMatch: 'full',
      },
    ],
  },
];
